<template>
  <div class="mt-1 bcru " >
    <v-chip  v-if="(this.desTL2 || this.desCountry)" @click.native="Country"
      class="opensanslight size10 ml-2 cursorhand"
      small
      left
      color="primary"
      text-color="white"
    >
        {{desCountry}} 
  
    </v-chip>
    <v-chip v-if="this.desTL2 !== ''" @click.native="TL2"
      class="ml-2 opensanslight size10 cursorhand"
      small
      color="purple"
      text-color="white"
      >
        {{desTL2}}
  
    </v-chip>
    <v-chip v-if="this.desTL3 !== ''"
        class="ml-2 opensanslight size10 cursorhand"
        small
        color="orange"
        text-color="white"
      >
        {{desTL3}}
  
    </v-chip>
  </div>
</template>

<script>
  export default {
    name: 'Breadcrumb',
    watch: {
      '$route' () {
      }
    },    
    methods: {
      refresh: function () {
          let params = this.$route.params
          if (params.tl === 'TL2') {
              this.desTL2 = this.$store.getters.getTL2ByCode(params.tu).name
              this.keyTL2 = params.tu
          }
          if (params.tl === 'TL3') {
              let obj = this.$store.getters.getTL3ByCode(params.tu)
              this.desTL3 = obj.name
              this.keyTL3 = params.tu

              this.desTL2 = this.$store.getters.getTL2ByCode(obj.parent).name
              this.keyTL2 = obj.parent
              
          }

          this.desCountry = this.$store.getters.country
          this.CountryId = this.$store.getters.countryID

          this.$root.$once('component_refresh', () => {this.refresh()})
      },      
     TL2: function () {
        let params = this.$route.params
        let query = this.$route.query
        if (params.tl !== 'TL2') {
          this.$store.dispatch('setkeyTL3', '')
          this.$store.dispatch('setdesTL3', '')
          params.tu = this.keyTL2
          params.tl = 'TL2'
          this.$router.replace({ name: 'SubArea', params: params, query: query})
          }
      },      
      Country: function () {
        this.$store.dispatch('setkeyTL2', '')
        this.$store.dispatch('setdesTL2', '')
        let params = this.$route.params
        let query = this.$route.query
        params.tu = 'x'
        this.$router.replace({ name: 'SubArea', params: params, query: query})
      }, 
    },
    data () {
      let desTL3 = ''
      let desTL2 = ''
      let keyTL3 = ''
      let keyTL2 = ''      
      let desCountry = ''
      let CountryId = ''
        return {
          desTL3, desTL2, keyTL3, keyTL2, desCountry, CountryId
        }    
    },
    beforeDestroy () { 
      delete this.desTL3
      delete this.desTL2
      delete this.keyTL3
      delete this.keyTL2
      delete this.desCountry
      delete this.CountryId
    },    
  mounted () {
        this.$root.$once('component_refresh', () => {this.refresh()})
        this.refresh()
  },    
  }
</script>
<style scoped>
  .bcru {width:100%; text-align: left;}
</style>
